import { Container } from '@/components/ui/Container'
import { Section } from '@/components/ui/Section'

export function ProductsHeroSection() {
  return (
    <Section surface="0" className="pt-10 pb-6 sm:pt-16 sm:pb-8 md:pt-20 md:pb-10">
      <Container className="max-w-4xl">
        <span className="font-mono text-xs uppercase tracking-widest text-fg-muted mb-3 sm:mb-4 block">
          Production Systems & Applications
        </span>
        <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-fg text-balance leading-tight">
          Platforms Engineered for Market Execution.
        </h1>
        <p className="mt-4 sm:mt-6 text-sm sm:text-lg md:text-xl text-fg-subtle leading-relaxed">
          A showcase of live client implementations, production foundations, and proprietary software suites — purpose-built for retail, enterprise logistics, mobility, and digital commerce.
        </p>
      </Container>
    </Section>
  )
}
